import React from "react";

export default class ErrorBoundary extends React.Component {
    state = { hasError: false, error: null };

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, info) {
        // eslint-disable-next-line no-console
        console.error("[ErrorBoundary]", error, info);
        if (typeof window !== "undefined" && window.posthog?.capture) {
            try {
                window.posthog.capture("frontend_error", {
                    error: String(error),
                    info: info?.componentStack?.split("\n").slice(0, 5).join("\n"),
                });
            } catch {}
        }
    }

    handleReload = () => window.location.reload();

    render() {
        if (this.state.hasError) {
            return (
                <div
                    data-testid="error-boundary"
                    className="container-edit py-24 text-center"
                >
                    <p className="overline text-terracotta mb-4">
                        Erreur inattendue
                    </p>
                    <h1 className="font-serif text-4xl md:text-5xl mb-4">
                        Quelque chose a mal tourné.
                    </h1>
                    <p className="text-ink/70 mb-8 max-w-md mx-auto leading-relaxed">
                        Recharge la page — si le problème persiste, dis-le-nous
                        et on jette un œil dans l&apos;atelier.
                    </p>
                    <button
                        onClick={this.handleReload}
                        data-testid="error-reload-btn"
                        className="btn-primary"
                    >
                        Recharger
                    </button>
                </div>
            );
        }
        return this.props.children;
    }
}
